import { render, staticRenderFns } from "./serviceManage.vue?vue&type=template&id=13e431cd&scoped=true&"
import script from "./serviceManage.vue?vue&type=script&lang=js&"
export * from "./serviceManage.vue?vue&type=script&lang=js&"
import style0 from "./serviceManage.vue?vue&type=style&index=0&id=13e431cd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e431cd",
  null
  
)

export default component.exports